module.exports = __webpack_public_path__ + "static/media/team_about_article_img_2_2025.169921d9.png";